export default __webpack_public_path__ + "static/media/notVerifiedIcon.3b9dd625.svg";